import React, { Component } from 'react';
import { Container, Header, Item, Image, Card } from 'semantic-ui-react';
import Carousel from 'react-multi-carousel';
import { Link } from 'react-router-dom';

const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 1600 },
      items: 5
    },
    superDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 1600, min: 1400 },
        items: 4
      },
    desktop: {
      breakpoint: { max: 1400, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

class PageCardList extends Component {

    render() {
        let carouselAry = [];
        for(let j=0; j<this.props.list.length; j++){
            carouselAry.push(
                <Link key={"card_" + j} to={"/page/"+this.props.list[j].toPage}>
                  <Card style={{margin: 10, marginLeft: "auto", marginRight: "auto", cursor: 'pointer'}}>
                      <Image src={this.props.list[j].img} wrapped ui={false} />
                  </Card>
                </Link>
            );
        }     
        return (
            <div style={{marginTop: "2em", marginBottom: "2em"}}>
                <Header as='h2'>{this.props.title}</Header>
                <p>{this.props.description}</p>
                <Carousel responsive={responsive} infinite={false}>
                    {carouselAry}                            
                </Carousel>
            </div>
        );
    }
}

export default PageCardList;



// WEBPACK FOOTER //
// ./src/components/PageComponents/PageCardList.js